<div class="zop-drawer-content">
    <ng-content></ng-content>
</div>